import { queryClient } from '@/src/lib/react-query/react-query';

import { INBOX_API_KEY } from './config';

export const invalidateInboxQueries = () => {
  return queryClient.invalidateQueries([INBOX_API_KEY]);
};

export const entryActionCustomValidateOptions = {
  showError: false,
  // validateStatus,
};
